import type { OptionType } from '@innovamat/glimmer-components';
import { LANGUAGES, REGIONS } from '@innovamat/localization';

function useDisplayRegions(): {
  languagesToOptions: (region?: string | null) => OptionType[];
  regions: OptionType[];
} {
  const regionsToOptions = (): OptionType[] => {
    return REGIONS.map((region) => ({
      label: region,
      value: region,
    }));
  };

  const languagesToOptions = (region?: string | null): OptionType[] => {
    if (!region) return [];

    const languages =
      LANGUAGES.region[region as keyof typeof LANGUAGES.region].locale;
    return Object.keys(languages).map((language) => ({
      label: language,
      value: language,
    }));
  };

  return {
    languagesToOptions,
    regions: regionsToOptions(),
  };
}

export { useDisplayRegions };
